import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import { useSelector } from "react-redux";

import ItemInputCard from "~business/Cards/ItemInputCard";
import ItemDominioCard from "~business/Cards/ItemDominioCard";
import ItemSelectorCard from "~business/Cards/ItemSelectorCard";
import { tieneGNCFilter, tieneGNCOptions } from "~constants/endosos";
import { VehiculoResponseEmision } from "~api/types";
import { OptionKV } from "~styled/selector/Selector";

const title = "Vehículo";

interface DatosVehiculoCardProps {
  isLoading: boolean;
}

const useReduxSelector = () =>
  useSelector<any, Partial<VehiculoResponseEmision>>((state) => {
    const datosVehiculo = state.detallePolizaNuevoReducer.currentPoliza
      ? state.detallePolizaNuevoReducer.currentPoliza.datosVehiculo
      : {};

    return {
      ...datosVehiculo,
    };
  });
/*
 */

const DatosVehiculoCard: React.FC<DatosVehiculoCardProps> = ({ isLoading }) => {
  const {
    marca,
    modelo,
    anio,
    codia,
    codigoPostal,
    nombreProvincia,
    nombreLocalidad,
    tieneGNC,
    dominio,
    numeroMotor,
    numeroChasis,
  } = useReduxSelector();

  const localidadFormatted =
    nombreProvincia && nombreLocalidad
      ? `(CP ${codigoPostal}) ${nombreLocalidad}, ${nombreProvincia}`
      : `(CP ${codigoPostal})`;

  const vehiculo = marca && modelo ? `(${anio}) ${marca} ${modelo}` : "";
  return (
    <DetalleCard title={title} IconHeader={DriveEtaIcon}>
      <ItemInputCard
        isLoading={isLoading}
        label={"Vehículo"}
        value={vehiculo.toUpperCase()}
        readOnly
      />
      <ItemInputCard
        isLoading={isLoading}
        label={"CODIA"}
        value={codia}
        readOnly
      />
      <ItemInputCard
        isLoading={isLoading}
        label={"Localidad"}
        value={localidadFormatted}
        readOnly
      />
      <ItemDominioCard
        isLoading={isLoading}
        label={"Dominio"}
        value={dominio}
        readOnly
      />
      <ItemInputCard
        label={"Número de Motor"}
        isLoading={isLoading}
        value={numeroMotor}
        readOnly
      />
      <ItemInputCard
        isLoading={isLoading}
        label={"Número de Chasis"}
        value={numeroChasis}
        readOnly
      />
      <ItemSelectorCard<boolean | null>
        isLoading={isLoading}
        label={"Tiene GNC"}
        value={tieneGNC ? tieneGNC : null}
        options={tieneGNCFilter as OptionKV<boolean | null>[]}
        valueOptions={tieneGNCOptions}
        variant="big"
        readOnly
        required
      />
    </DetalleCard>
  );
};

export default DatosVehiculoCard;
